import { Routes, Route, Navigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

import Login          from "./login/Login";
import ForgotPassword from "./forgot-password/ForgotPassword";
import MainLayout     from "../layouts/MainLayout";
import ProtectedRoute from "../components/ProtectedRoute";
import PublicRoute    from "../components/PublicRoute";
import FullScreenLoader from "../components/FullScreenLoader";

import Dashboard    from "../modules/swiftreach/dashboard/Dashboard";
import Campaigns    from "../modules/swiftreach/campaigns/Campaigns";
import Automations  from "../modules/swiftreach/automations/Automations";
import Contacts     from "../modules/swiftreach/contacts/Contacts";
import Templates    from "../modules/swiftreach/templates/Templates";
import Segments     from "../modules/swiftreach/segments/Segments";
import Analytics    from "../modules/swiftreach/analytics/Analytics";
import Settings     from "../modules/swiftreach/settings/Settings";
import YourAccount  from "../modules/swiftreach/your-account/page";
import LoginSecurity from "../modules/swiftreach/login-security/page";
import NotFound     from "../modules/swiftreach/not-found/page";

function RootRedirect() {
  const { user, loading } = useContext(AuthContext);
  if (loading) return <FullScreenLoader />;
  return user
    ? <Navigate to="/swiftreach/dashboard" replace />
    : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="*"                element={<RootRedirect />} />
      <Route path="/login"           element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />

      <Route path="/swiftreach" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
        <Route index                    element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard"         element={<Dashboard />} />
        <Route path="campaigns"         element={<Campaigns />} />
        <Route path="automations"       element={<Automations />} />
        <Route path="contacts"          element={<Contacts />} />
        <Route path="templates"         element={<Templates />} />
        <Route path="segments"          element={<Segments />} />
        <Route path="analytics"         element={<Analytics />} />
        <Route path="settings"          element={<Settings />} />
        <Route path="your-account"      element={<YourAccount />} />
        <Route path="login-security"    element={<LoginSecurity />} />
        <Route path="*"                 element={<NotFound />} />
      </Route>
    </Routes>
  );
}
